/**
 * Canonical design tokens for the web 2.0 UI.
 *
 * The hex values mirror the CSS custom properties declared in `src/assets/new-design.css` — that
 * stylesheet remains the source of truth for values only expressible in CSS (the oklch brand
 * ramps). Use `zinc` for JS/sx styling and the `brand*` var() references where a brand color is
 * needed outside CSS.
 */

/** Zinc neutral scale; identical to the `--color-zinc-*` custom properties. */
export const zinc = {
  50: "#fafafa",
  100: "#f4f4f5",
  200: "#e4e4e7",
  300: "#d4d4d8",
  400: "#a1a1aa",
  500: "#71717a",
  600: "#52525b",
  700: "#3f3f46",
  800: "#27272a",
  900: "#18181b",
  950: "#09090b",
} as const;

/** Brand primary ramp as CSS var() references (values live in new-design.css as oklch). */
export const brandPrimary = {
  DEFAULT: "var(--color-brand-primary)",
  50: "var(--color-brand-primary-50)",
  100: "var(--color-brand-primary-100)",
  200: "var(--color-brand-primary-200)",
  300: "var(--color-brand-primary-300)",
  400: "var(--color-brand-primary-400)",
  500: "var(--color-brand-primary-500)",
  600: "var(--color-brand-primary-600)",
  700: "var(--color-brand-primary-700)",
  800: "var(--color-brand-primary-800)",
  900: "var(--color-brand-primary-900)",
  950: "var(--color-brand-primary-950)",
} as const;

/** The brand's slate teal, its one hue apart from the purples, as CSS var() references (values in new-design.css). */
export const brandOther = {
  DEFAULT: "var(--color-brand-other)",
  50: "var(--color-brand-other-50)",
  100: "var(--color-brand-other-100)",
  200: "var(--color-brand-other-200)",
  300: "var(--color-brand-other-300)",
  400: "var(--color-brand-other-400)",
  500: "var(--color-brand-other-500)",
  600: "var(--color-brand-other-600)",
  700: "var(--color-brand-other-700)",
} as const;

/** Alt brand ramp as CSS var() references (values live in new-design.css as oklch). */
export const altBrand = {
  DEFAULT: "var(--color-alt-brand)",
  50: "var(--color-alt-brand-50)",
  100: "var(--color-alt-brand-100)",
  200: "var(--color-alt-brand-200)",
  300: "var(--color-alt-brand-300)",
  400: "var(--color-alt-brand-400)",
  500: "var(--color-alt-brand-500)",
  600: "var(--color-alt-brand-600)",
  700: "var(--color-alt-brand-700)",
  800: "var(--color-alt-brand-800)",
  900: "var(--color-alt-brand-900)",
  950: "var(--color-alt-brand-950)",
} as const;
